import { render, staticRenderFns } from "./change-method.vue?vue&type=template&id=d263fe3a&scoped=true&"
import script from "./change-method.vue?vue&type=script&lang=js&"
export * from "./change-method.vue?vue&type=script&lang=js&"
import style0 from "./change-method.vue?vue&type=style&index=0&id=d263fe3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d263fe3a",
  null
  
)

export default component.exports